module.exports = __webpack_public_path__ + "static/media/neww.9cff63aa.png";